import { ComponentProps } from 'react';
import { isUndefined } from '../../predicates/type';
import { CopyToClipboard } from '../CopyToClipboard';
import { FlexGrid } from '../FlexGrid';
import { IconButton } from '../IconButton';
import { Copy } from '../Icons/Copy';
import classes from '../PasswordTextbox/styles/passwordPreview.module.scss';
import { withPreview } from '../decorators/withPreview';
import { Textbox } from './Textbox';
import { TextBoxProps } from './types';
import RouteLink from '../RouteLink';

export const TextBoxWithPreview = withPreview<ComponentProps<typeof Textbox>>(Textbox);

export const formatPreviewWithClipboard = (props: TextBoxProps) => {
	return (
		<FlexGrid
			center
			spaceBetween
		>
			{props.value}
			{!isUndefined(props.value) && (
				<CopyToClipboard
					value={props.value}
					render={({ onCopyButtonClick }) => (
						<IconButton
							onClick={onCopyButtonClick}
							dataTestId='copyButton'
							link
							className={classes.icon_button}
						>
							<Copy />
						</IconButton>
					)}
				/>
			)}
		</FlexGrid>
	);
};

export const formatPreviewWithEMailLink = (props: TextBoxProps) => {
	if (!props.value) return props.value;

	return (
		<RouteLink
			href={`mailto:${props.value}`}
			target='_blank'
		>
			{props.value}
		</RouteLink>
	);
};

export const formatPreviewWithLink = (props: TextBoxProps) => {
	if (!props.value) return props.value;

	return (
		<RouteLink
			target='_blank'
			href={`${props.value}`}
		>
			{props.value}
		</RouteLink>
	);
};
